import React, { useRef, useState } from "react";
import styles from "./PinInput.module.css";
import clsx from "clsx"
import { showConsoleMessage } from "../util/ConsoleMessage";

const BACK_SPACE_KEY = "Backspace"

export enum PinInputState {
    default = "default", 
    success = "success", 
    error = "error" 
}

type PinInputProps = {
    size?: number;
    onPinChange?: (pin: string) => void; 
    state?: PinInputState;
    obscure?: boolean;
};

export default function PinInput({ size = 4, onPinChange, state = PinInputState.default, obscure }: PinInputProps) {
    const inputRefs = useRef<Record<number, HTMLInputElement | null>>({})
    const [pin, setPin] = useState<Array<number | undefined>>(new Array(size))

    const changePinFocus = (index: number) => {
        var ref = inputRefs.current[index];
        if (ref) {
            ref.focus()
        } else {
            ref = inputRefs.current[index - 1]
            if (ref) ref.blur()
        }
    }

    const handleChange = (event: any, index: number) => {
        const value = event.target.value.replace(/[^0-9]/g, "").trim();
        const newPin = [...pin]
        if (value === "" || Number.isNaN(value)) {
            newPin[index] = undefined
        } else {
            if (newPin[index] === undefined) newPin[index] = value
            changePinFocus(index + 1)
        }
        setPin(newPin)
        if (onPinChange) onPinChange(newPin.join(""))
    }

    const onKeyDown = (event: any, index: number) => {
        if (event.key !== BACK_SPACE_KEY) {
            return
        }
        if (pin[index] === undefined) {
            changePinFocus(index - 1)
        }
    }

    var maskedPin = obscure ? pin.map(value => value ? "•" : "") : pin.map(value => value ? `${value}` : "")
    showConsoleMessage(state)
    return <div className={styles['input-wrapper']}>{
        Array.from({ length: size }, (_, index) => {
            return <input className={clsx(styles['input-field'], {[styles[state]]: state})}
                value={maskedPin[index] || ""}
                key={`pin_input_${index}`}
                ref={element => {
                    if (element) {
                        inputRefs.current[index] = element
                    }
                }}
                onKeyDown={(event) => onKeyDown(event, index)}
                onChange={(event) => handleChange(event, index)}
            />
        })
    }</div>
}